var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ele-dialog"},[_c('el-dialog',_vm._g(_vm._b({attrs:{"modal-append-to-body":false}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("title",null,{"slot":"title"}),_vm._t("default"),_vm._t("footer",null,{"slot":"footer"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }